module.exports = __webpack_public_path__ + "static/media/Image_3.58459930.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureBlock/images/Image_3.jpg
// module id = 848
// module chunks = 0